import { TFunction } from 'i18next'

import { PasskeyErrorReason } from './authenticatePasskey/useAuthenticatePasskey'

export function getPasskeyErrorMessage(t: TFunction, reason: Exclude<PasskeyErrorReason, 'user-initiated'>) {
  if (reason === 'deleted-passkey') {
    return t('This passkey can no longer be used to sign in. Try another passkey, or use your phone number or email.', {
      context: 'error',
    })
  }
  if (reason === 'risk-blocked') {
    return t('Something went wrong. Enter your phone number or email to sign in instead.', { context: 'error' })
  }
  if (reason === 'unsupported-browser') {
    return t('This browser does not support passkeys. Enter your phone number or email instead.', { context: 'error' })
  }
  return t('Something went wrong. Please try again.', { context: 'error' })
}
